export default "__VITE_ASSET__4a3af9ed__"